import { render, staticRenderFns } from "./UploadDocs.vue?vue&type=template&id=35b0ce31&scoped=true"
import script from "./UploadDocs.vue?vue&type=script&lang=js"
export * from "./UploadDocs.vue?vue&type=script&lang=js"
import style0 from "./UploadDocs.vue?vue&type=style&index=0&id=35b0ce31&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b0ce31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b0ce31')) {
      api.createRecord('35b0ce31', component.options)
    } else {
      api.reload('35b0ce31', component.options)
    }
    module.hot.accept("./UploadDocs.vue?vue&type=template&id=35b0ce31&scoped=true", function () {
      api.rerender('35b0ce31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popups/show-docs-popup/upload-docs/UploadDocs.vue"
export default component.exports